import styles from './TrustBar.module.css'
import useReveal from '../hooks/useReveal.js'
import CountUp from './CountUp.jsx'

const STATS = [
  { value: '11,400+', label: 'candidates placed since 2019' },
  { value: '48 hrs', label: 'average time to first shortlist' },
  { value: '4.8 / 5', label: 'average employer rating' },
  { value: '0%', label: 'fee if we don\u2019t make a placement' },
]

export default function TrustBar() {
  const [ref, visible] = useReveal(0.4)

  return (
    <section className={styles.bar}>
      <div className={`container ${styles.inner}`} ref={ref}>
        <p className={styles.lead}>Since 2019, matching Kiwi talent with Kiwi teams.</p>
        <dl className={`${styles.stats} ${visible ? styles.visible : ''}`}>
          {STATS.map((s) => (
            <div key={s.label} className={styles.stat}>
              <dt className={styles.value}>
                <CountUp value={s.value} start={visible} />
              </dt>
              <dd className={styles.label}>{s.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  )
}
